import { AISHA_API_BASE } from '@/constants';

export interface MenuImageUploadResponse {
  public_url: string;
  image_type: string;
  filename: string;
}

export interface MenuImageUploadError {
  error: string;
  details?: string;
}

/**
 * メニュー管理用の画像アップロードAPI
 */
export const uploadMenuImage = async (
  imageFile: File,
  imageType: 'sample_input' | 'sample_result' | 'usage_guide' | 'menu_reference' | 'menu_reference_video'
): Promise<MenuImageUploadResponse> => {
  const formData = new FormData();
  formData.append('image', imageFile);
  formData.append('image_type', imageType);

  const response = await fetch(`${AISHA_API_BASE}/menu-images/upload/`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const errorData: MenuImageUploadError = await response.json();
    throw new Error(errorData.error || '画像のアップロードに失敗しました');
  }

  return response.json();
}; 
/**
 * 人物参照画像を2960(Renoise)エンジンにアセット登録する
 * 管理メニューで人物参照をセットしたタイミングで呼び出す
 */
export const registerRenoiseAsset = async (
  imageUrl: string,
  name: string,
): Promise<{ success: boolean; asset_id?: string; cached?: boolean; error?: string }> => {
  try {
    const response = await fetch(`${AISHA_API_BASE}/renoise-assets/register/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ image_url: imageUrl, name }),
    });
    const data = await response.json();
    if (!response.ok) {
      return { success: false, error: data.error || `HTTP ${response.status}` };
    }
    return data;
  } catch (e) {
    return { success: false, error: String(e) };
  }
};

export interface RenoiseAsset {
  id: number;
  name: string;
  thumbnail_url?: string;
  status?: string;
  asset_type?: string;
}

/**
 * Renoiseに登録済みのアセット一覧を取得
 */
export const fetchRenoiseAssets = async (): Promise<RenoiseAsset[]> => {
  try {
    const response = await fetch(`${AISHA_API_BASE}/renoise-assets/`);
    if (!response.ok) return [];
    const data = await response.json();
    return data.assets || [];
  } catch {
    return [];
  }
};
